module.exports = __webpack_public_path__ + "img/selected0-min.bcc1e531.png";